import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

/** Resolve the account scope separately from the user performing an action. */
export function useHotelPartnerId() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['hotel-partner-id', user?.id],
    enabled: !!user?.id,
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: async (): Promise<string | null> => {
      const { data, error } = await (supabase as any).rpc('rle_hotel_partner_id');
      if (error) throw error;
      return typeof data === 'string' && data ? data : null;
    },
  });
}